import { MouseEventHandler, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageTitle from '../components/custom/components/PageTitle'
import VerticalLayout from '../components/custom/layouts/Vertical'
import Modal from '../components/Modal'
import RouteMasterForm from '../components/RouteMasterForm'
import { ToastTypes, useToast } from '../components/toast/ToastProvider'
import { FormType, FormTypeList } from '../components/types'
import { addKey, isInToday } from '../config/functions'
import { AuthUserType } from '../redux/actions/authUserActions'
import { deleteRouteMaster, RouteMasterType } from '../redux/actions/routeMasterActions'
import { Key } from '../redux/actions/types'
import { StoreState } from '../redux/reducers'
import { AppDispatch } from '../redux/store'

interface TableBody {
    sno: number
    code: string
    name: string
    startPoint: string
    endPoint: string
    KM: string
    numberOfStops: string
    numberOfStages: string
    tripCount: string
    onEdit: MouseEventHandler<HTMLButtonElement>
    onDelete: MouseEventHandler<HTMLButtonElement>
    timeStamp: string
    authUser: AuthUserType
}

type HandleEdit = (value: RouteMasterType) => void
type HandleDelete = (value: RouteMasterType) => void

const RouteMaster = () => {
    const toast = useToast()

    const dispatch = useDispatch<AppDispatch>()
    const authUser = useSelector<StoreState, AuthUserType>(state => state.authUser)


    const RouteMaster = useSelector<StoreState, Array<RouteMasterType & Key>>(state => addKey(state.routeMaster))
    const [showForm, setShowForm] = useState<boolean>(false)
    const [formType, setFormType] = useState<FormType>(FormTypeList.ADD)
    const [editData, setEditData] = useState<RouteMasterType>()

    const handleAdd = () => {
        setShowForm(true)
    }

    const handleEdit: HandleEdit = (value) => {
        setFormType(FormTypeList.UPDATE)
        setEditData(value)
        setShowForm(true)
    }

    const handleDelete: HandleDelete = (value) => {
        if (value.id !== undefined) {
            dispatch(deleteRouteMaster(value.id)).then(text => {
                toast(text)
            }).catch(text => {
                toast(text, ToastTypes.ERROR)
            })
        }
    }

    const handleFormClose = () => {
        setShowForm(false)
        setFormType(FormTypeList.ADD)
        setEditData(undefined)
    }

    return <>
        <Modal
            headerText={formType === FormTypeList.ADD ? 'Add Route Master' : 'Edit Route Master'}
            visible={showForm}
            onClose={handleFormClose}
            size='xl'
            centered
        >
            <RouteMasterForm
                formType={formType}
                editData={editData}
                onSave={handleFormClose}
            />

        </Modal>
        <VerticalLayout>
            <PageTitle
                title='Route Master'
                buttonText='ADD'
                onButtonClick={handleAdd}
            />
            <div className="card">
                <div className="card-body">
                    <div className='table-wrapper'>
                        <table className='table colored'>
                            <thead>
                                <tr>
                                    <th className='text-truncate align-middle'>S.No</th>
                                    <th className='text-truncate align-middle'>Code</th>
                                    <th className='text-truncate align-middle'>Name</th>
                                    <th className='text-truncate align-middle'>Start Point</th>
                                    <th className='text-truncate align-middle'>End Point</th>
                                    <th className='text-truncate align-middle'>Total KM</th>
                                    <th className='text-truncate align-middle'>No.Of.Stops</th>
                                    <th className='text-truncate align-middle'>No.Of.Stages</th>
                                    <th className='text-truncate align-middle'>No.Of.Trips/day</th>
                                    <th className='text-truncate align-middle text-center'>Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {RouteMaster.filter(rm => {
                                    return rm.code !== "HIRE"
                                }).map((rm, i) => {
                                    return <RouteMasterBody
                                        sno={i + 1}
                                        code={rm.code !== undefined ? rm.code : ''}
                                        name={rm.name}
                                        startPoint={rm.startPoint}
                                        endPoint={rm.endPoint}
                                        KM={rm.totalKm}
                                        numberOfStages={rm.stageNumber}
                                        numberOfStops={rm.stopsNumber}
                                        tripCount={rm.tripsPerDay}
                                        key={rm.key}
                                        authUser={authUser}
                                        timeStamp={rm.createTimestamp !== undefined ? rm.createTimestamp : ''}
                                        onEdit={() => handleEdit(rm)}
                                        onDelete={() => handleDelete(rm)}
                                    />
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </VerticalLayout>
    </>
}

const RouteMasterBody = ({ sno, code, startPoint, endPoint, KM, name, numberOfStages, numberOfStops, tripCount, onEdit, onDelete, timeStamp, authUser }: TableBody) => {
    const ShowEditForManager = isInToday(timeStamp)

    return <tr>
        <td>{sno}</td>
        <td>{code}</td>
        <td className='text-capitalize'>{name}</td>
        <td className='text-capitalize'>{startPoint}</td>
        <td className='text-capitalize'>{endPoint}</td>
        <td>{KM}</td>
        <td>{numberOfStops}</td>
        <td>{numberOfStages}</td>
        <td>{tripCount}</td>
        <td >
            <div className='hstack gap-1'>
                {(authUser.role === 'admin' || authUser.role === 'super' || authUser.role === 'Admin' || authUser.role === 'Super') && <button className='btn btn-xs btn-primary' onClick={onEdit}>Edit</button>}
                {(authUser.role === 'Manager' || authUser.role === 'manager') && ShowEditForManager && <button className='btn btn-xs btn-primary' onClick={onEdit}>Edit</button>}
                <button className='btn btn-xs btn-danger' onClick={onDelete}>Delete</button>
            </div>
        </td>
    </tr>
}

export default RouteMaster
